import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ProductMockup() {
  const benefits = ['The first 7 things you must do in the 30 days after inheriting a property — in order', 'How to avoid the #1 mistake heirs make that costs an average of $12,000 in unnecessary taxes', 'The exact conversation to have with your siblings or co-heirs before anyone gets a lawyer involved', 'Sell, rent, or keep? A simple 3-question framework that tells you which option is right for your situation', 'How to read a title report without a law degree — and what to do if something looks wrong', 'The probate process explained in plain English — what it is, how long it takes, and how to speed it up', 'A room-by-room personal property checklist so nothing of value gets thrown away or overlooked', 'How to protect yourself legally if the property has outstanding debt or liens', 'What every heir over 55 needs to know about capital gains tax before signing anything'];
  return <section className="bg-warm-white py-12 md:py-28 px-6" data-id="element-376">
      <div className="max-w-7xl mx-auto" data-id="element-377">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-20" data-id="element-378">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2 flex justify-center" data-id="element-379">
            <img src="https://cdn.magicpatterns.com/uploads/oX2LZCxnZrxMK6dkG7L1fj/The_inherited_house_iPad_iPhone_image.png" alt="The Inherited House Digital Guide on Tablet and Phone" className="w-full max-w-lg object-contain drop-shadow-editorial" data-id="element-380" />
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-1/2" data-id="element-381">
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-8 leading-tight" data-id="element-382">
              Inside The Inherited House Survival Kit, you'll discover:
            </h2>

            <ul className="space-y-4" data-id="element-383">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-384">
                  <div className="flex-shrink-0 mt-1" data-id="element-385">
                    <CheckIcon className="w-6 h-6 text-green-600" data-id="element-386" />
                  </div>
                  <span className="text-lg text-text-dark font-body leading-relaxed" data-id="element-387">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}